import type { ClientId } from '~ng-common-lib/core/tokens/environment';

export enum ClientEnvironmentName {
	PRODUCTION = 'production',
	STAGING = 'staging',
	DEVELOPMENT = 'development',
	LOCAL = 'local',
}

export interface ClientEnvironment {
	production: boolean;

	environmentName: ClientEnvironmentName;

	/** Tenant selected at build-time; drives `CLIENT_CONFIG` / `getClientConfig`. */
	clientId: ClientId;

	sentryDSN?: string;

	clientUrl: string;

	frontendUrl: string;

	apiBaseUrl: string;

	socialSignIn: {
		googleClientId: string;
		appleClientId: string;
		microsoftClientId: string;
		microsoftAuthority: string;
	};

	landingUrl: string;

	googleAdsId?: string;

	googleAnalyticsId?: string;

	zapierAppLink?: string;

	imageCdn?: string;

	googleMapsApiKey?: string;

	handbookUrl: string;
	organizationDashboardUrl: string;
}
